<template>
  <div class="settled">
    <div class="settled-title">
      <img src="../assets/settled/settled-title.png" />
    </div>
    <div class="form">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="企业名称" prop="companyName">
          <el-input
            v-model="ruleForm.companyName"
            placeholder="请输入企业名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系人员" prop="contacts">
          <el-input
            v-model="ruleForm.contacts"
            placeholder="请输入联系人员"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="contactsPhone">
          <el-input
            v-model="ruleForm.contactsPhone"
            placeholder="请输入联系电话"
          ></el-input>
        </el-form-item>
        <el-form-item label="行业类型" prop="companyType">
          <!-- <el-input v-model="ruleForm.companyType"></el-input> -->
          <el-select
            v-model="value"
            clearable
            placeholder="请选择行业类型"
            @change="change(value)"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')"
            >立即申请</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { userMakeOrder, typeList } from "../api/home";
export default {
  data() {
    return {
      ruleForm: {
        contacts: "",
        companyName: "",
        contactsPhone: "",
        companyType: "",
      },
      rules: {
        companyName: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        contacts: [
          { required: true, message: "请输入联系人", trigger: "blur" },
        ],
        contactsPhone: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
        ],
        companyType: [
          { required: true, message: "请输入行业类型", trigger: "blur" },
        ],
      },
      options: [],
      value: "",
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      typeList().then((res) => {
        if (res.code == 200) {
          let typeList = [];
          typeList = res.data;
          typeList.forEach((e) => {
            this.options.push({ value: e.dictValue, label: e.dictValue });
          });
        }
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          userMakeOrder(this.ruleForm).then((res) => {
            if (res.code == 200) {
              this.ruleForm = "";
              this.value = "";
              this.$message({
                showClose: true,
                message:
                  "资料提交成功！请耐心等待，稍后会有工作人员给您取得联系。",
                type: "success",
                offset: 126,
              });
            } else {
              this.$message({
                showClose: true,
                message: res.msg,
                type: "error",
              });
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    //行业类型选择
    change(val) {
      this.ruleForm.companyType = val;
    },
  },
};
</script>

<style lang="less" scoped>
.settled {
  padding: 81px 0 269px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  .settled-title {
    // text-align: center;
    margin-bottom: 92px;
  }
  .form {
    //    padding:0 570px;
    //    text-align: center;

    .el-form {
      .el-form-item {
        .el-input {
          width: 600px;
        }
        .el-button--primary {
          padding: 21px 214px;
          background: #d32e39;
          border: 0;
          font-size: 24px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #ffffff;
          margin-top: 124px;
        }
        .el-select {
          width: 600px;
        }
      }
    }
  }
}
</style>